import { useQuery } from '@apollo/client';

import { getVendorAvailabilityList } from '@/api';
import { resolveGqlErrors } from '@/helpers';

import type { ProductType, VendorAvailabilityListItem } from '../types';

type UseAvailabilityList = {
  loading: boolean;
  error: string;
  restaurants: VendorAvailabilityListItem[];
  refetch: () => void;
};

export const useAvailabilityList = (): UseAvailabilityList => {
  const { loading, data, error, refetch } = useQuery(getVendorAvailabilityList, {
    fetchPolicy: 'cache-first',
  });

  const rawVendors = data?.getVendorAvailabilityList?.vendors ?? [];

  const restaurants: VendorAvailabilityListItem[] = rawVendors.map((v) => ({
    vendorId: v.vendorId,
    internalName: v.internalName,
    markets: v.markets,
    productType: v.productType as ProductType,
    availabilityStatus: v.availabilityStatus,
    submissionStatus: v.submissionStatus,
    windowStatus: v.windowStatus,
    deadlineDate: v.deadlineDate ?? null,
    requiresSubmission: v.requiresSubmission,
    submission: v.submission
      ? {
          submittedAt: v.submission.submittedAt ?? '',
          submittedByEmail: v.submission.submittedByEmail ?? '',
          version: v.submission.version ?? 0,
        }
      : null,
  }));

  return {
    loading,
    error: resolveGqlErrors(error || data?.getVendorAvailabilityList?.error),
    restaurants,
    refetch,
  };
};
